import MainPage from './Components/MainPage'
import Game from './Components/Game'
import { useGlobalContext } from './context'

function App() {
  const {play } = useGlobalContext();
  if (!play) 
    return (<MainPage></MainPage>)
  else 
    return (<Game></Game>)
}

export default App;
